import { render, staticRenderFns } from "./SubtitlesOverlay.vue?vue&type=template&id=0161b6d8&scoped=true"
import script from "./SubtitlesOverlay.vue?vue&type=script&lang=js"
export * from "./SubtitlesOverlay.vue?vue&type=script&lang=js"
import style0 from "./SubtitlesOverlay.vue?vue&type=style&index=0&id=0161b6d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0161b6d8",
  null
  
)

export default component.exports